export default {
  title: 'Night of the Living Picks',
  bannerAlt: 'Night of the Living Picks — $10,000 Splash Cash Giveaway',
  terms: 'Terms and Official Rules',
  summary: {
    night: 'Night {{number}} of {{total}}',
    live: 'Live',
    alive: 'still alive',
    eliminated: 'Eliminated',
    playing: 'Still playing',
    safe: 'Safe tonight',
    share: 'Each survivor’s share right now',
    winnerShare: 'Each winner’s share',
    grows: 'Grows as the field shrinks, up to {{cap}}',
    nights: 'Night by night',
    nightLabel: 'Night {{number}}',
    entered: '{{count}} entered',
    survived: '{{percent}} survived',
    safeCount: '{{count}} safe',
    out: '{{count}} out',
    pending: '{{count}} playing',
    notStarted: 'Not started',
    bar: '{{survived}} survived, {{eliminated}} eliminated, {{pending}} pending',
  },
  eyebrow: 'QuickPicks Halloween survivor',
  description: '3 nights. Hit a perfect slip in your first 3 each night to stay standing.',
  leftStanding: 'Left standing',
  winnersLabel: 'Winners',
  entered: 'Entered',
  prizePool: 'Prize pool',
  teaser: 'Starts Sat, Oct 31 at 12:00 AM ET.',
  boardOpens: 'The board opens Saturday',
  howToEnter:
    'Play a real-money QuickPicks slip of $5.00 or more on a Saturday game and you’re in. One revive is available the next night only: a perfect 4+ pick slip on Sunday or 5+ pick slip on Monday.',
  live: 'Night {{number}} of 3 is live.',
  settling: 'Awaiting final results. Slips are still settling.',
  final: 'Final results.',
  fallback: 'No one survived {{day}}. The previous night’s survivors win.',
  wipeout: 'No one survived the first night. There are no winners.',
  provisional: 'Everyone is out. Awaiting final results.',
  noWinners: 'No souls left standing',
  winners: 'Last ones standing',
  each: 'Each, in bonus funds',
  standing: '{{count}} still standing',
  eliminated: '{{count}} eliminated',
  winner: 'Winner',
  unnamed: 'Unnamed player',
  safe: 'Safe tonight',
  inPlay__hasPlural: { one: '{{count}} slip in play', other: '{{count}} slips in play' },
  slipsLeft__hasPlural: {
    one: '{{count}} slip left to play',
    other: '{{count}} slips left to play',
  },
  pendingSlips: 'Pending slips',
  out: 'Out on {{day}}',
  allNights: 'Survived all 3 nights',
  revivedOn: 'Revived on {{day}}',
  mark: {
    survived: 'Survived',
    revived: 'Revived',
    pending: 'In play',
    out: 'Out',
    'not-started': 'Not started',
  },
  more: 'Show 50 more',
  loading: 'Loading the leaderboard',
  night: { saturday: 'Sat', sunday: 'Sun', monday: 'Mon' },
  error: 'Couldn’t load the leaderboard',
  errorHint: 'We’ll keep trying every minute.',
  retry: 'Try again',
  refreshError: "Couldn't refresh. Showing results from {{time}} ET",
  empty: 'No players have entered yet. Check back soon.',
  eligibility: 'All slips are verified for eligibility before prizes are paid.',
};
